// headless is generating the role
import { FC } from "react";

interface IRadioStyledProps {
  id: string;
}

const RadioStyled: FC<IRadioStyledProps> = ({ id }) => {
  return (
    <>
      {/* eslint-disable jsx-a11y/role-has-required-aria-props */}
      <span
        id={id}
        role="radio"
        className="flex size-4 min-w-4 items-center justify-center rounded-full border-2 border-gray-400 group-data-checked:border-blueHighlighted bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark group-data-disabled:bg-gray-100 group-data-disabled:border-gray-400 "
      >
        {/* eslint-enable jsx-a11y/role-has-required-aria-props */}
        <span className="invisible size-2 rounded-full bg-blueHighlighted group-data-checked:visible"></span>
      </span>
    </>
  );
};

export default RadioStyled;
